import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import type { ComponentType, FC, PropsWithChildren } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary } from 'react-error-boundary';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const GlobalErrorBoundaryFallback: FC<FallbackProps> = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
      <Typography variant="h3" component="h1">
        An unexpected error happened :(
      </Typography>
    </Box>
  );
};

type GlobalErrorBoundaryT = PropsWithChildren & {
  FallbackComponent?: ComponentType<FallbackProps>;
}
const GlobalErrorBoundary: FC<GlobalErrorBoundaryT> =
  ({
     children,
     FallbackComponent,
   }) => {
    const { reset } = useQueryErrorResetBoundary();

    return (
      <ErrorBoundary onReset={reset} FallbackComponent={FallbackComponent ?? GlobalErrorBoundaryFallback}>
        {children}
      </ErrorBoundary>
    );
  };

export default GlobalErrorBoundary;
